import React from "react";
import styled from "styled-components";

import {
  DEGUSTACAO_MIGRATION_MESSAGE,
  isDegustacaoPlan,
  type CadastroPlan,
} from "../plans";

const Notice = styled.div`
  margin-top: 16px;
  padding: 12px 14px;
  border: 1px solid #b3e6d8;
  border-radius: 7px;
  background: #eefaf6;
  color: #155f4d;
  font-size: 13px;
  line-height: 1.45;
`;

type Props = {
  plan?: Pick<CadastroPlan, "id"> | null;
};

const DegustacaoMigrationNotice = ({ plan }: Props) => {
  if (!isDegustacaoPlan(plan)) return null;

  return (
    <Notice role="status" aria-live="polite">
      {DEGUSTACAO_MIGRATION_MESSAGE}
    </Notice>
  );
};

export default DegustacaoMigrationNotice;
